var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0214731A-B5E6-43BA-8796-5C8D793379F5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Final-Template-Arun",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Helix-Template-1.9B",
    transform: "translate(-108.000000, -1104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(108.000000, 1104.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#75A1FC",
    cx: 22.5,
    cy: 22.5,
    r: 22.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    cx: 22.5,
    cy: 22.5,
    r: 12.2142857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2994458,34.5051725 L21.2994458,24.7273114 L18.5672269,24.7273114 L18.5672269,21.6823498 L21.2994458,21.6823498 L21.2994458,19.4416337 C21.2994458,16.8429597 22.9583761,15.4285714 25.3824442,15.4285714 C26.5432491,15.4285714 27.5410524,15.5113341 27.8319328,15.5482619 L27.8319328,18.2642139 L26.1603892,18.2642139 C24.8416279,18.2642139 24.5862585,18.8635939 24.5862585,19.7429938 L24.5862585,21.6823498 L27.7395651,21.6823498 L27.328568,24.7273114 L24.5862585,24.7273114 L24.5862585,34.5051725 C21.9244911,34.975027 21.2249307,34.5064715 21.2994458,34.5051725 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ea2e7344.svg";
export { ForwardRef as ReactComponent };